import { z } from 'zod'

export const editUserSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  email: z.string().email('Invalid email address').min(1, 'Email is required'),
  phone: z.string().min(1, 'Phone number is required'),
  bio: z.string().min(1, 'Bio is required'),
  gender: z.enum(['male', 'female', 'other'], {
    required_error: 'Gender is required',
  }),
  dateOfBirth: z.string().min(1, 'Date of birth is required'),
  active: z.boolean().default(true),
  image: z.any().optional(),
})

export type EditUserFormData = z.infer<typeof editUserSchema>
